export const SUPPORTED_LANGUAGES = ['sk', 'en'];
